import type { SymbolDefinition } from "../types.ts";

export const terminalBlock: SymbolDefinition = {
  id: "ep-terminal",
  familyKey: "terminal",
  deviceKind: "terminal",
  version: "0.1.0",
  label: { sv: "Plint", en: "Terminal" },
  description: { sv: "Plintnummer.", en: "Terminal block point." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <circle cx="12" cy="12" r="4" fill="currentColor"/>
      <line x1="12" y1="2" x2="12" y2="8"/>
      <line x1="12" y1="16" x2="12" y2="22"/>
    </g>
  `,
  terminals: [
    { id: "a", kind: "phase", label: "1", position: "top", offset: 0.5 },
    { id: "b", kind: "phase", label: "2", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "X",
  searchKeywords: ["plint", "terminal"],
};
